import { FC } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { FileTypeIcon } from '@/shared/components/FileTypeIcon';
import { COLORS } from '@/shared/constants/colors';
// import { Icon } from '@/shared/uikit/Icon';
import { Icon } from '@/shared/uikit/Icon';
import { Spinner } from '@/shared/uikitV2/Spinner';

import { FileItemInfo } from '../types';

type StatusProps = {
  fileInfo: FileItemInfo;
};

export const Status: FC<StatusProps> = ({ fileInfo }) => {
  const { file } = fileInfo;

  const dataError = !fileInfo.isValidType || !fileInfo.isValidSize;

  const error = dataError || fileInfo.isUploadError;
  const idle = !error && !fileInfo.uploading;
  const loading = !error && fileInfo.uploading;

  return (
    <Container className={cn({ loading, error })}>
      {idle && <FileTypeIcon type={file.type} size="s20" />}
      {loading && <Spinner />}
      {dataError && <Icon name="warning-octagon" size="s20" />}
      {fileInfo.isUploadError && <Icon name="arrow-clockwise" />}
    </Container>
  );
};

const Container = styled.div`
  width: 28px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${COLORS.systemDark200};
  color: ${COLORS.systemLight100};

  &.loading {
    background: ${COLORS.systemDark100};
    color: ${COLORS.systemDark300};
  }

  &.error {
    background: ${COLORS.systemFlame100};
    color: ${COLORS.systemFlame200};
  }

  .spinner {
    animation: spin 1000ms steps(8) infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
